import type {
  SlideDetailAdapterResult,
  SlideDetailAdapterResultKey,
} from '@/common/types/slideDetailAdapter.types';

export const createSlideDetailResult = (
  key: SlideDetailAdapterResultKey,
): SlideDetailAdapterResult => {
  if (key === 'ok') return { opened: true };

  return {
    opened: false,
    reason: key,
  };
};
